import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Slider.css";
import ladyMicroscopePic from "../../assets/Homepage_slider/lady_microscope.jpg";
import lab_staff from "../../assets/Homepage_slider/lab_staff.jpg";
import capsule from "../../assets/Homepage_slider/capsule.jpg";
import microscope from "../../assets/Homepage_slider/microscope.jpeg";

const slides = [
  {
    image: lab_staff,
    title: "Complete molecular characterization",
    subtitle: "1H-NMR, 13C-NMR, Mass, IR, HPLC & TGA",
    // button: "Know more",
  },
  {
    image: capsule,
    title: "Custom Reference Standards",
    subtitle: "Certified pharma reference materials",
    //button: "Explore now",
  },
  {
    image: microscope,
    title: "Trusted by Global Pharma",
    subtitle: "350+ Qualified experts. ISO certified.",
    // button: "Get in touch",
  },
];

const Slider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000); // change every 5 seconds
    return () => clearInterval(interval);
  }, []);
  const { image, title, subtitle, button } = slides[current];

  return (
    <div>

  
    <div
      className="slider"
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <div className="slider-content">
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
    </div>
     </div>
  );
};

export default Slider;
